module.exports = require('./lib/static/prefixAll')



//////////////////
// WEBPACK FOOTER
// ./~/inline-style-prefixer/static.js
// module id = 1888
// module chunks = 0